module.exports = __webpack_public_path__ + "media/images/stat-current-streak-8bb27949.svg";